(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bm-calendar"] && !Shopify.designMode) return;
  try {
    
function initBookmoriCalendar(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const config=JSON.parse(root.querySelector('[data-bm-calendar-config]').textContent),form=root.querySelector('.bm-calendar__form'),button=form.querySelector('[type=submit]'),error=form.querySelector('[role=alert]');
 root.querySelectorAll('[name=bm_quantity]').forEach(input=>input.addEventListener('change',()=>{
  const qty=Number(input.value);root.querySelectorAll('[data-pack]').forEach(pack=>{const active=Number(pack.dataset.pack)===qty;pack.classList.toggle('is-selected',active);pack.querySelector('.bm-calendar__colours').hidden=!active;});
  root.querySelectorAll('[data-gift-threshold]').forEach(gift=>{const active=Number(gift.dataset.giftThreshold)<=qty;gift.classList.toggle('is-unlocked',active);gift.querySelector('.bm-calendar__gift-status').textContent=active?config.unlocked:config.locked;});
 }));
 const slides=root.querySelector('.bm-calendar__slides');root.querySelectorAll('[data-bm-slide]').forEach(thumb=>thumb.addEventListener('click',()=>{slides.scrollTo({left:slides.clientWidth*Number(thumb.dataset.bmSlide),behavior:'smooth'});}));
 slides.addEventListener('scroll',()=>{const current=Math.round(slides.scrollLeft/slides.clientWidth);root.querySelectorAll('[data-bm-slide]').forEach(t=>t.setAttribute('aria-current',String(Number(t.dataset.bmSlide)===current)));},{passive:true});
 async function add(items,trigger){const old=trigger.innerHTML;trigger.disabled=true;trigger.textContent=config.adding;error.hidden=true;try{const drawer=document.querySelector('cart-drawer');const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items,sections:drawer?drawer.getSectionsToRender().map(x=>x.id):['cart-icon-bubble'],sections_url:location.pathname})});const data=await response.json();if(!response.ok||data.status)throw new Error(data.description||config.error);if(window.bmCalendarGifts)await window.bmCalendarGifts.sync();if(drawer){const render=await window.bmCalendarGifts.sections();drawer.classList.remove('is-empty');drawer.setActiveElement(trigger);drawer.renderContents(render);}else location.href=window.Shopify.routes.root+'cart';}catch(e){error.textContent=e.message||config.error;error.hidden=false;}finally{trigger.innerHTML=old;trigger.disabled=false;}}
 form.addEventListener('submit',event=>{event.preventDefault();const pack=root.querySelector('[data-pack].is-selected');const items=Array.from(pack.querySelectorAll('[data-bm-variant]'),s=>({id:Number(s.value),quantity:1}));add(items,button);});
 root.querySelectorAll('[data-bm-upsell]').forEach(b=>b.addEventListener('click',()=>add([{id:Number(b.closest('.bm-calendar__upsell').querySelector('select').value),quantity:1}],b)));
 const sticky=root.querySelector('.bm-calendar__sticky');new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||entries[0].boundingClientRect.top>0;}).observe(form);
}
document.querySelectorAll('.bm-calendar').forEach(initBookmoriCalendar);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.bm-calendar').forEach(initBookmoriCalendar));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
